/**
 * The MTA-STS validation statuses.
 */
export enum IRcaMtaStsValidationStatus {
  /**
   * The missing configuration status.
   */
  ConfigurationNotPresent = 0,

  /**
   * The invalid configuration status for not correctly formatted fields.
   */
  InvalidConfiguation,

  /**
   * The success status for correctly formatted fields.
   */
  Success,
}
